import { render, staticRenderFns } from "./comm-head.vue?vue&type=template&id=60babd58&scoped=true&"
import script from "./comm-head.vue?vue&type=script&lang=js&"
export * from "./comm-head.vue?vue&type=script&lang=js&"
import style0 from "./comm-head.vue?vue&type=style&index=0&id=60babd58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60babd58",
  null
  
)

export default component.exports